import { alpha } from '@mui/system'
import { makeStyles } from '@material-ui/core/styles'
// import Slider, { sliderClasses } from '@mui/base/Slider'
import { sliderClasses } from '@mui/base/Slider'
import { Slider } from '@mui/base'

const MultiStageSlider = ({
  marks,
  onChange,
  selectedIem,
  setSelectedItem,
  disabled
}) => {
  const classes = useStyles({ disabled, selectedIem })

  const handleChange = e => {
    setSelectedItem(e.target.value)
    onChange(e.target.value)
  }

  return (
    <Slider
      className={classes.root}
      value={selectedIem}
      step={null}
      marks={marks.map(item => ({ value: item.value, label: '' }))}
      onChange={e => handleChange(e)}
      disabled={disabled}
    />
  )
}

export default MultiStageSlider

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
    height: '0px',
    width: '100%',
    padding: '16px 0',
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
    touchAction: 'none',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      opacity: 1
    },
    [`&.${sliderClasses.disabled}`]: {
      pointerEvents: 'none',
      cursor: 'default',
      color: theme.palette.primary.main
    },
    [`& .${sliderClasses.rail}`]: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: '10px',
      borderRadius: '5px',
      backgroundColor: theme.palette.quaternary.main,
      border: `1px solid ${theme.palette.secondary.main}`,
      opacity: 1
    },
    [`& .${sliderClasses.track}`]: {
      display: 'block',
      position: 'absolute',
      height: '4px',
      borderRadius: '2px',
      backgroundColor: 'none'
    },
    [`& .${sliderClasses.thumb}`]: {
      position: 'absolute',
      width: '15px',
      height: '15px',
      marginLeft: '-6px',
      // marginTop: '-6px',
      boxSizing: 'border-box',
      borderRadius: '50%',
      outline: 0,
      border: `3px solid ${props =>
        props.disabled
          ? theme.palette.primary.main
          : theme.palette.primary.accent}`,
      backgroundColor: props =>
        props.disabled
          ? theme.palette.primary.main
          : theme.palette.primary.accent,
      top: '44%',

      [`&:hover, &.${sliderClasses.focusVisible}`]: {
        boxShadow: `0 0 0 0.25rem ${alpha(theme.palette.primary.accent, 0.15)}`
      },

      [`&.${sliderClasses.active}`]: {
        boxShadow: `0 0 0 0.25rem ${alpha(theme.palette.primary.accent, 0.3)}`
      }
    },
    [`& .${sliderClasses.mark}`]: {
      position: 'absolute',
      width: '15px',
      height: '15px',
      borderRadius: '100%',
      backgroundColor: 'none',
      top: '44%',
      transform: `translateX(-50%)`
    },
    [`& .${sliderClasses.markActive}`]: {
      backgroundColor: 'none'
    }
  }
}))
